import { generateApiRoute } from '@klp/core/api/helpers';
import { baseApi } from '@klp/core/api/services/rtkApi';
import { triggerChange } from '@klp/core/app/store';
import { clearMiljoprofilEnvVariables } from '@klp/sustainability/config';
import { ParamType, clearStorage, saveToStorage } from '@klp/utils';

import { Client } from '../../classes';
import type { ClientSelectRequest, IClient } from '../../classes';

import { updateSelectedCustomer } from './intercom';

export const userClientsApiName = 'bruker';

export const userClientsApiRoutes = {
    byToken: () => generateApiRoute([userClientsApiName, 'bytoken']),
};

export const clientApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getUserClients: builder.query<
            Array<Client>,
            ClientSelectRequest | undefined
        >({
            query: (request) => ({
                url: userClientsApiRoutes.byToken(),
                params: request,
            }),
            transformResponse: (response: any) => {
                const tilganger =
                    response?.data?.tilganger || response?.tilganger || [];
                return tilganger
                    ?.filter((user: IClient) => Boolean(user?.kundeNummer))
                    .map((user: IClient) => Client.parseObject(user));
            },
            providesTags: ['Client'],
        }),

        selectClient: builder.mutation<null, Client>({
            queryFn: async (client, { dispatch }) => {
                try {
                    // Save to localStorage
                    saveToStorage(ParamType.selectedClient, client);

                    // Update Intercom
                    updateSelectedCustomer(client);

                    // Clear environment variables
                    clearMiljoprofilEnvVariables();

                    // Trigger app-wide change
                    dispatch(triggerChange());

                    return { data: null };
                } catch (error: any) {
                    return {
                        error: {
                            status: 500,
                            data: error.message,
                        },
                    };
                }
            },
        }),

        resetClient: builder.mutation<null, void>({
            queryFn: async (_, { dispatch }) => {
                try {
                    // Clear localStorage
                    clearStorage(ParamType.selectedClient);

                    // Clear environment variables
                    clearMiljoprofilEnvVariables();

                    // Trigger app-wide change
                    dispatch(triggerChange());

                    return { data: null };
                } catch (error: any) {
                    return {
                        error: {
                            status: 500,
                            data: error.message,
                        },
                    };
                }
            },
        }),
    }),
});

export const {
    useGetUserClientsQuery,
    useSelectClientMutation,
    useResetClientMutation,
} = clientApi;
